import { Input } from '@/components/ui/input.js';
import { Label } from '@/components/ui/label.js';
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';

export interface PoolDetailsValues {
  name: string;
  description: string;
}

interface PoolDetailsFieldsProps {
  defaultName?: string;
  defaultDescription?: string | null;
  onHasNameChange: (hasName: boolean) => void;
}

const nameInputId = 'teachers-availabilities-pool-name';
const descriptionInputId = 'teachers-availabilities-pool-description';

// Name and description shared by creating and editing a teacher pool
export const PoolDetailsFields = forwardRef<PoolDetailsValues, PoolDetailsFieldsProps>(function PoolDetailsFields(
  { defaultName = '', defaultDescription = '', onHasNameChange },
  ref,
) {
  const [name, setName] = useState(defaultName);
  const [description, setDescription] = useState(defaultDescription ?? '');

  useImperativeHandle(ref, () => ({ name, description }), [name, description]);

  useEffect(() => {
    onHasNameChange(name.trim().length > 0);
  }, [name, onHasNameChange]);

  return (
    <div className="mx-2 mb-2 grid shrink-0 gap-4 sm:grid-cols-2 pt-4">
      <div className="flex min-w-0 flex-col gap-1.5">
        <Label htmlFor={nameInputId} className="font-semibold">
          Pool name
          <span className="text-destructive" aria-hidden="true">
            {' '}
            *
          </span>
        </Label>
        <Input
          id={nameInputId}
          required
          value={name}
          onChange={(event) => setName(event.target.value)}
          data-testid="teachers-availabilities-pool-input-name"
        />
      </div>
      <div className="flex min-w-0 flex-col gap-1.5">
        <Label htmlFor={descriptionInputId} className="font-semibold">
          Description (optional)
        </Label>
        <Input
          id={descriptionInputId}
          value={description}
          onChange={(event) => setDescription(event.target.value)}
          data-testid="teachers-availabilities-pool-input-description"
        />
      </div>
    </div>
  );
});
